export function inPromoPeriod(PromotionModalComponent) {
    if (PromotionModalComponent.__start_date__ && !(new Date() >= PromotionModalComponent.__start_date__)) {
        return false;
    }

    if (PromotionModalComponent.__end_date__ && !(new Date() < new Date(PromotionModalComponent.__end_date__.getTime() + (1000 * 60 * 60 * 24)))) {
        return false;
    }

    return true;
}

export function showPromo(PromotionModalComponent, memberData) {
    if (PromotionModalComponent.__override_condition__ && PromotionModalComponent.__override_condition__(memberData)) {
        return true;
    }

    if (PromotionModalComponent.__start_date__ && !(new Date() >= (PromotionModalComponent.__display_start_date__ || PromotionModalComponent.__start_date__))) {
        return false;
    }

    if (PromotionModalComponent.__start_time__ && !(new Date() >= (PromotionModalComponent.__display_start_time__ || PromotionModalComponent.__display_start_date__ || PromotionModalComponent.__start_time__))) {
        return false;
    }

    if (PromotionModalComponent.__end_date__ && !(new Date() < new Date(PromotionModalComponent.__end_date__.getTime() + (1000 * 60 * 60 * 24)))) {
        return false;
    }

    if (PromotionModalComponent.__end_time__ && !(new Date() < PromotionModalComponent.__end_time__)) {
        return false;
    }

    if (PromotionModalComponent.__additional_condition__ && !PromotionModalComponent.__additional_condition__(memberData)) {
        return false;
    }

    return true;
}
